import React from "react";
import { AvatarLabelGroup, Card, CardHeader } from "@opendate-app/setlist";
import initialsFor from "../../ClassesShared/initials";
import personColorProps from "../../ClassesShared/personColor";
import DetailField from "./DetailField";
import { formatDateRange } from "../../ClassesShared/classLabels";
import { useRegistrationPageContext } from "./RegistrationPageContext";
import "../../ClassesShared/classesShared.css";

export default function ClassCard() {
  const { registration, paths } = useRegistrationPageContext();
  const { class_info: classInfo, time_zone: timeZone } = registration.dashboard;

  return (
    <Card header={<CardHeader title="Class" />}>
      <dl className="row mb-0">
        <DetailField label="Class" wide><a href={paths.classInstance}>{classInfo.name}</a></DetailField>
        <DetailField label="When" wide>{formatDateRange(classInfo.starts_at, classInfo.ends_at, timeZone)}</DetailField>
        <DetailField label="Where" wide>{classInfo.where}</DetailField>
        <DetailField label={classInfo.instructors.length === 1 ? "Instructor" : "Instructors"} wide>
          {classInfo.instructors.length > 0 && (
            <div className="d-flex flex-column classes-gap-8">
              {classInfo.instructors.map((name) => <AvatarLabelGroup key={name} size="xs" initials={initialsFor(name)} {...personColorProps(name)} name={name} />)}
            </div>
          )}
        </DetailField>
      </dl>
    </Card>
  );
}
